export default __webpack_public_path__ + "static/media/coin.f67f9b51.svg";